import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useShallow } from 'zustand/react/shallow';
import { STORAGE_KEY } from '@/constants';
import { useHistoryStore } from '@/stores/HistoryStore/useHistoryStore';
const setHistoryExpire = () => {
  sessionStorage.setItem(STORAGE_KEY.HISTORY_EXPIRE, (Date.now() + 5_000).toString());
};
const HistoryObserverController = () => {
  const $ = _c(11);
  const searchParams = useSearchParams()?.toString();
  const pathname = usePathname();
  let url;
  if ($[0] !== pathname || $[1] !== searchParams) {
    url = pathname || "";
    if (searchParams) {
      url = url + `?${searchParams}`;
      url;
    }
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = url;
  } else {
    url = $[2];
  }
  const [setCustomHistory, setHistoryIndex] = useHistoryStore(useShallow(_temp));
  let t0;
  if ($[3] !== setCustomHistory || $[4] !== setHistoryIndex || $[5] !== url) {
    t0 = () => {
      const {
        historyIndex,
        customHistory
      } = useHistoryStore.getState();
      const historyState = history.state ?? {};
      if (typeof historyState.historyIndex === "number") {
        customHistory.set(historyState.historyIndex, url);
      } else {
        const hasReplaceMark = sessionStorage.getItem(STORAGE_KEY.REPLACE_MARK) === "true";
        historyState.historyIndex = historyIndex;
        if (hasReplaceMark) {
          sessionStorage.removeItem(STORAGE_KEY.REPLACE_MARK);
          customHistory.set(historyIndex, url);
        } else {
          historyState.historyIndex = historyState.historyIndex + 1;
          customHistory.set(historyState.historyIndex, url);
        }
        history.replaceState(historyState, "");
      }
      setHistoryIndex(historyState.historyIndex);
      setCustomHistory(customHistory);
      window.addEventListener("pagehide", setHistoryExpire);
      return _temp2;
    };
    $[3] = setCustomHistory;
    $[4] = setHistoryIndex;
    $[5] = url;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== setCustomHistory || $[8] !== setHistoryIndex || $[9] !== url) {
    t1 = [url, setCustomHistory, setHistoryIndex];
    $[7] = setCustomHistory;
    $[8] = setHistoryIndex;
    $[9] = url;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  useEffect(t0, t1);
  return null;
};
export const HistoryObserver = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorBoundary fallback={null}><Suspense><HistoryObserverController /></Suspense></ErrorBoundary>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(state) {
  return [state.setCustomHistory, state.setHistoryIndex];
}
function _temp2() {
  window.removeEventListener("pagehide", setHistoryExpire);
}